import React from 'react'

import { Box, Typography } from "@mui/material"


export default function acrissColumn() {

	return {
		name: 'acriss',
		label: 'ACRISS Code',
		options: {
			customBodyRowRenderLite: value => <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
				<Typography>{value || "Any"}</Typography>
			</Box>,
		}
	}
}